import ApiService from '../api.services';

const UserNotificationService = {
    list: async function () {
        try {
            const response = await ApiService.get(`/api/users/notification/list/pendencies`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    notifications: async function (id) {
        try {
            const response = await ApiService.get(`/api/users/notification/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    download: async function (id) {
        try {
            const response = await ApiService.post(`/api/users/notification/download/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    delete: async function (id) {
        try {
            const response = await ApiService.delete(`/api/users/notification/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

export default UserNotificationService;

export { UserNotificationService };

